import React, { useEffect, useState } from "react";
import HomeIcon from "@mui/icons-material/Home";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import PersonIcon from "@mui/icons-material/Person";
import { Link, useLocation } from "react-router-dom";

export default function SecurityNavbar() {
  const [isVisible, setIsVisible] = useState(true);
  const location = useLocation();

  useEffect(() => {
    // Function to check if navbar should be hidden
    const checkVisibility = () => {
      const hideNavbar = document.body.classList.contains("hide-navbar");
      // Check for both group chat and direct chat routes
      const isChatRoute =
        location.pathname.includes("/group-chats/") ||
        location.pathname.includes("/chats/");
      setIsVisible(!hideNavbar && !isChatRoute);
    };

    // Check initially
    checkVisibility();

    // Set up a mutation observer to watch for class changes on body
    const observer = new MutationObserver(checkVisibility);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });

    // Cleanup
    return () => observer.disconnect();
  }, [location.pathname]);

  const navItems = [
    {
      label: "Home",
      icon: <HomeIcon />,
      link: "/",
    },
    {
      label: "Scan QR Code",
      icon: <QrCodeScannerIcon />,
      link: "/qr",
    },
    {
      label: "Chat",
      icon: <ChatBubbleIcon />,
      link: "/chat",
    },
    {
      label: "Profile",
      icon: <PersonIcon />,
      link: "/profile",
    },
  ];

  if (!isVisible) return null;

  return (
    <div className="flex justify-around text-center bg-gray-200 text-gray-600 pb-8 pt-2 rounded-t-xl">
      {navItems.map((item, index) => (
        <div
          key={index}
          className="flex flex-col items-center justify-start p-2 cursor-pointer hover:bg-green-400 rounded-lg
          w-20 h-20
          "
        >
          <Link to={item.link} className="text-center">
            {item.icon}
            <div className="text-xs text-center">{item.label}</div>
          </Link>
        </div>
      ))}
    </div>
  );
}
